import React, { Component } from 'react'
import { connect } from 'react-redux'
import { History } from 'history'
import { withRouter } from 'react-router-dom'
import VehicleDetailsForm from './vehicleDetailsForm'
import { updateVehicle } from '../../refiApp/refiActions'
import { Vehicle } from '../../../core/types'

export type Callback<T = void> = (...args: any) => T

const initialDetailValues = (vehicle) => {
  if (vehicle.id) {
    const newVehicle = Object.assign({}, vehicle)
    return newVehicle
  } else {
    return null
  }
}

export function formatMileage(mileage) {
  if (Number.isInteger(mileage)) {
    return mileage
  } else {
    return Number(mileage.replace(/[^0-9\.]+/g, ''))
  }
}

export function formatVehicleFormData(data: Vehicle) {
  const {
    id,
    mileage,
    transmission,
    condition,
    selected_option_ids,
    selected_trim_id,
  } = data

  const newValues = {
    id,
    transmission,
    condition,
    selected_trim_id,
    selected_option_ids,
    mileage: formatMileage(mileage),
    doFraudCheck: true,
  }

  return newValues
}

export interface Props {
  history: History
  updateVehicle: Callback<Promise<any>>
  returnUrl: string
  vehicle: Vehicle
  controls: Callback
}

export class VehicleDetailFormSanitizer extends Component<Props> {
  onSubmit = (data) => {
    const { history, updateVehicle, returnUrl, vehicle } = this.props
    vehicle.mileage = data.mileage

    return updateVehicle(formatVehicleFormData(vehicle)).then(() => {
      if (returnUrl) {
        history.push(returnUrl)
      }
    })
  }

  render() {
    const { vehicle, controls } = this.props

    return (
      <div>
        {vehicle.id && (
          <VehicleDetailsForm
            onSubmit={this.onSubmit}
            vehicle={vehicle}
            controls={controls}
            initialValues={initialDetailValues(vehicle)}
          />
        )}
      </div>
    )
  }
}

export default withRouter(
  connect(null, {
    updateVehicle,
  })(VehicleDetailFormSanitizer)
)
